import { useQuery, useMutation } from '@apollo/client'
import { Form, message } from 'antd'

import { CREATE_WORKER_WITH_USER, GET_WORKERS_FOR_SEARCH } from './graphQL'
import { getVariablesFromForm, WorkerForm } from './WorkerForm'

import { Button } from '@/components/shared-components/BUI/Button'
import { Modal } from '@/components/shared-components/BUI/Modal'
import { useProject } from '@/context/projectContext'
import { GET_BUILDER_SUBBIES_FOR_SEARCH } from '@/modules/subcontractors/graphQL'

import {
  BuilderSubbiesForSearchUiQuery,
  BuilderSubbiesForSearchUiQueryVariables,
  CreateWorkerWithUserUiMutation,
  CreateWorkerWithUserUiMutationVariables,
} from 'types/api.graphql'

const NewWorkerModal = ({ isVisible, handleCancel, handleSuccess }) => {
  const { isProjectSelected, project } = useProject()

  const { data: builderSubbies } = useQuery<
    BuilderSubbiesForSearchUiQuery,
    BuilderSubbiesForSearchUiQueryVariables
  >(GET_BUILDER_SUBBIES_FOR_SEARCH, {
    fetchPolicy: 'cache-and-network',
    variables: { filter: { includeBuilderSubcontractor: true } },
  })

  const [createWorker, { loading: creating }] = useMutation<
    CreateWorkerWithUserUiMutation,
    CreateWorkerWithUserUiMutationVariables
  >(CREATE_WORKER_WITH_USER, {
    refetchQueries: [{ query: GET_WORKERS_FOR_SEARCH }],
    awaitRefetchQueries: true,
  })

  const onSubmit = async (values) => {
    const { data, errors } = await createWorker({
      variables: {
        input: {
          ...getVariablesFromForm(values),
          builderGenerated: true,
          projectId: isProjectSelected ? project.id : undefined,
        },
      },
    })

    if (errors?.length) {
      message.error(
        'Something went wrong creating the worker. Make sure all fields are filled in correctly.'
      )
      return
    }

    handleSuccess(data.createWorkerWithUser)
    message.success(`Created new worker`)
  }

  return (
    <Modal
      title="Create worker"
      open={isVisible}
      onCancel={handleCancel}
      footer={
        <Button type="submit" variant="primary" loading={creating}>
          Create worker
        </Button>
      }
      modalRender={(children) => (
        <Form layout="vertical" onFinish={onSubmit}>
          {children}
        </Form>
      )}
    >
      <WorkerForm subbies={builderSubbies?.subcontractorsByBuilder ?? []} />
    </Modal>
  )
}

export default NewWorkerModal
